const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
] as const;

/**
 * Formats an experience date range.
 *
 * § D stores these at month precision with the day always 01, and the spec never says
 * how they render — the prototype shows year only, which would make 2023-01 and 2023-12
 * indistinguishable and look like a bug to whoever entered them. Month and year, so the
 * stored precision is actually visible.
 *
 * Formatted client-side and NOT with Intl: the API sets InvariantGlobalization, and
 * locale-dependent month names would make the layout shift by locale for no benefit on
 * an English-only site.
 */
export function formatDateRange(startDate: string, endDate: string | null): string {
  const start = formatMonth(startDate);
  const end = endDate === null ? 'Present' : formatMonth(endDate);

  return `${start} — ${end}`;
}

function formatMonth(isoDate: string): string {
  // Parsed by hand rather than via Date: `new Date('2023-03-01')` is UTC midnight, which
  // in a negative-offset timezone renders as February.
  const [year, month] = isoDate.split('-');
  const monthIndex = Number(month) - 1;

  if (!year || Number.isNaN(monthIndex) || monthIndex < 0 || monthIndex > 11) {
    return isoDate;
  }

  return `${MONTHS[monthIndex]} ${year}`;
}
